import { render, staticRenderFns } from "./StratageInfo.vue?vue&type=template&id=def9b4fe&scoped=true&"
import script from "./StratageInfo.vue?vue&type=script&lang=js&"
export * from "./StratageInfo.vue?vue&type=script&lang=js&"
import style0 from "./StratageInfo.vue?vue&type=style&index=0&id=def9b4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def9b4fe",
  null
  
)

export default component.exports